/**
 * Custom fetch wrapper that automatically appends test profile to API calls
 * in development mode
 */

const originalFetch = window.fetch;

window.fetch = function(...args) {
  let [url, options] = args;

  // Only append test profile in development mode and for API calls
  if (process.env.NODE_ENV === 'development' && typeof url === 'string' && url.startsWith('/api')) {
    const testProfile = localStorage.getItem('simpleodds_test_profile');

    if (testProfile) {
      // Parse URL and append testProfile parameter
      const urlObj = new URL(url, window.location.origin);
      urlObj.searchParams.set('testProfile', testProfile);
      url = urlObj.pathname + urlObj.search;
    }
  }

  return originalFetch(url, options);
};

export default window.fetch;
